import _ from "lodash";
import API from "../../../../Config/axios";
import { normalizeDuplicateClusters } from "./duplicateClusters";

export const onGetDataDuplicate = ({
  page = 1,
  limit = 20,
  is_duplicate,
  keyword = "",
}) => {
  const tempParams = {
    page,
    limit,
    is_duplicate,
    group_duplicates: 1,
    keyword,
  };

  const filteredParams = _.pickBy(tempParams, (value) => !!value);

  // Pencarian memakai endpoint search dengan filter duplikat yang sama,
  // sehingga hasilnya tetap berupa klaster.
  const url = keyword ? "/parents/search" : "/parents";

  const response = API.get(url, {
    params: {
      ...filteredParams,
    },
  })
    .then((res) => {
      return {
        data: normalizeDuplicateClusters(res?.data?.parents),
        error: false,
      };
    })
    .catch(() => {
      return {
        data: normalizeDuplicateClusters([]),
        error: true,
      };
    });

  return response;
};
